var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.6,
    height: 17.965,
    viewBox: "0 0 20.6 17.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(0 -0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M20.167,32.7.21,40.452a.329.329,0,0,0-.042.593L4.3,43.375l1.435,7.016a.329.329,0,0,0,.058.135l.008.01a.329.329,0,0,0,.206.121l.032,0h.021a.327.327,0,0,0,.173-.049.323.323,0,0,0,.049-.037l.013-.012,3.113-3.121a.329.329,0,0,0-.466-.465L6.5,49.429,7.028,44.9,14.5,49a.328.328,0,0,0,.235.031l.024-.007a.328.328,0,0,0,.184-.149l.006-.011a.329.329,0,0,0,.021-.048l5.629-15.7C20.639,33,20.287,32.654,20.167,32.7ZM1.1,40.813l3.487,1.965Zm5.455,3.311a.329.329,0,0,0-.078.091l-.008.014a.328.328,0,0,0-.035.12l-.456,3.908L4.963,43.316,16.04,36.148Zm7.923,4.117L7.337,44.323Z",
    transform: "translate(0 -32.697)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send2.23e43fd5faaefc6f6591c5c9ce9c873f.svg";
export { ForwardRef as ReactComponent };